import type { components } from '../../infra/broker.openapi';
import { PING_SERVICE_UUID, TenantJobSearchParams } from '../core';

type SearchJobsRequest = components['schemas']['SearchJobsRequest'];
type JobSearchCondition = components['schemas']['JobSearchCondition'];

/**
 * Maps the page-level search params to the Broker `POST /jobs/search` body.
 * Internal services are always excluded (same filter as the Logs tab's per-object search).
 */
export const TenantJobSearchRequestBuilder = {
	build({ page, perPage, filters }: TenantJobSearchParams): SearchJobsRequest {
		const conditions: JobSearchCondition[] = [{ field: 'serviceUUID', doesNotEqual: [PING_SERVICE_UUID] }];

		if (filters?.serviceUUIDs?.length) {
			conditions.push({ field: 'serviceUUID', equals: filters.serviceUUIDs });
		}
		if (filters?.excludedServiceUUIDs?.length) {
			conditions.push({ field: 'serviceUUID', doesNotEqual: filters.excludedServiceUUIDs });
		}
		if (filters?.statuses?.length) {
			conditions.push({ field: 'status', equals: filters.statuses });
		}
		if (filters?.triggeredBy?.length) {
			conditions.push({ field: 'triggeredBy', equals: filters.triggeredBy });
		}
		if (filters?.triggeredByDisplayName?.equals?.length) {
			conditions.push({ field: 'triggeredByDisplayName', equals: filters.triggeredByDisplayName.equals });
		}
		if (filters?.triggeredByDisplayName?.startsWith?.length) {
			conditions.push({ field: 'triggeredByDisplayName', startsWith: filters.triggeredByDisplayName.startsWith });
		}

		return { filters: conditions, page, perPage };
	},
};
